import React from "react";
import InnerBanner from "../../common/InnerBanner";
import "../../styles/faq.css";

const FaqPg = () => {
  return (
    <div>
      <InnerBanner name="FAQ" />
      <div className="faq_main container">
        <div className="faq_section dm-sans">
          <h2>General Question</h2>
          <div class="accordion" id="accordionExample1">
            {[1, 2, 3, 4].map((item) => (
              <div class="accordion-item">
                <h2 class="accordion-header" id={`heading${item}`}>
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item}`}
                    aria-expanded="true"
                    aria-controls={`collapse${item}`}
                  >
                    Accordion Item {item}
                  </button>
                </h2>
                <div
                  id={`collapse${item}`}
                  class="accordion-collapse collapse"
                  aria-labelledby={`heading${item}`}
                  data-bs-parent="#accordionExample1"
                >
                  <div class="accordion-body">
                    <strong>This is the first item's accordion body.</strong>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="faq_section dm-sans">
          <h2>General Question</h2>
          <div class="accordion" id="accordionExample2">
            {[5, 6, 7, 8].map((item) => (
              <div class="accordion-item">
                <h2 class="accordion-header" id={`heading${item}`}>
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item}`}
                    aria-expanded="true"
                    aria-controls={`collapse${item}`}
                  >
                    Accordion Item {item}
                  </button>
                </h2>
                <div
                  id={`collapse${item}`}
                  class="accordion-collapse collapse"
                  aria-labelledby={`heading${item}`}
                  data-bs-parent="#accordionExample2"
                >
                  <div class="accordion-body">
                    <strong>This is the first item's accordion body.</strong>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="faq_section dm-sans">
          <h2>General Question</h2>
          <div class="accordion" id="accordionExample3">
            {[9, 10, 11, 12].map((item) => (
              <div class="accordion-item">
                <h2 class="accordion-header" id={`heading${item}`}>
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item}`}
                    aria-expanded="true"
                    aria-controls={`collapse${item}`}
                  >
                    Accordion Item {item}
                  </button>
                </h2>
                <div
                  id={`collapse${item}`}
                  class="accordion-collapse collapse"
                  aria-labelledby={`heading${item}`}
                  data-bs-parent="#accordionExample3"
                >
                  <div class="accordion-body">
                    <strong>This is the first item's accordion body.</strong>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="faq_section dm-sans">
          <h2>General Question</h2>
          <div class="accordion" id="accordionExample4">
            {["One", "Two", "Three", "Four"].map((item) => (
              <div class="accordion-item">
                <h2 class="accordion-header" id={`heading${item}`}>
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${item}`}
                    aria-expanded="true"
                    aria-controls={`collapse${item}`}
                  >
                    Accordion Item {item}
                  </button>
                </h2>
                <div
                  id={`collapse${item}`}
                  class="accordion-collapse collapse"
                  aria-labelledby={`heading${item}`}
                  data-bs-parent="#accordionExample4"
                >
                  <div class="accordion-body">
                    <strong>This is the first item's accordion body.</strong>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqPg;
